import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  EquipmentResponse,
  SelectEquipmentActionType,
} from './equipments.types'
import { mockTractor } from './equipments.fixtures'

export interface EquipmentState {
  selectedEquipment: EquipmentResponse
}

const initialState: EquipmentState = {
  selectedEquipment: mockTractor,
}

export const equipmentSlice = createSlice({
  name: 'equipment',
  initialState,
  reducers: {
    setSelectedEquipment: (
      state,
      action: PayloadAction<SelectEquipmentActionType>
    ) => {
      state.selectedEquipment = action.payload.equipment
    },
  },
})

export const { setSelectedEquipment } = equipmentSlice.actions

export default equipmentSlice.reducer
